

















import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class LoadingScreen extends Vue {
  @Prop({ type: Boolean, default: true })
  animateLoading: Boolean
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingScreen.vue